import moment from "moment";
import TemplateExtractionApi from "../../Api/Services/AppflyteBackend/TemplateExtractionApi";
import { getSessionData } from "../sessionDataHandle";

export const getAllMainExtractionDocumentTypes = async () => {
    const tempArr = []
    let last_evaluated_key = null
    try {
        do {
            const response = await TemplateExtractionApi.getMainDocumentTypes(last_evaluated_key);
            if (response.data) {
                const collectionData = response.data.published_collections_detail.flatMap(collection => response.data[collection.id]);
                if (collectionData) {
                    tempArr.push(...collectionData)
                }
            }
            last_evaluated_key = response.data.last_evaluated_key != null && response.data.last_evaluated_key !== "" ? encodeURIComponent(JSON.stringify(response.data.last_evaluated_key)) : null
        }
        while (last_evaluated_key !== null)
        return tempArr;
    }
    catch (error) {
        console.error(error)
        return []
    }
};

export const getAllCustomExtractionDocumentTypes = async () => {
    const tempArr = []
    let last_evaluated_key = null
    try {
        do {
            const response = await TemplateExtractionApi.getCustomDocumentTypes(last_evaluated_key);
            if (response.data) {
                const collectionData = response.data.published_collections_detail.flatMap(collection => response.data[collection.id]);
                if (collectionData) {
                    tempArr.push(...collectionData)
                }
            }
            last_evaluated_key = response.data.last_evaluated_key != null && response.data.last_evaluated_key !== "" ? encodeURIComponent(JSON.stringify(response.data.last_evaluated_key)) : null
        }
        while (last_evaluated_key !== null)
        return tempArr;
    }
    catch (error) {
        console.error(error)
        return []
    }
};

export const getAllExtractionDocumentTypes = async (project_id) => {
    const tempArr = []
    let last_evaluated_key = null
    try {
        do {
            const response = await TemplateExtractionApi.getDocumentTypes(last_evaluated_key, project_id);
            if (response.data) {
                const collectionData = response.data.published_collections_detail.flatMap(collection => response.data[collection.id]);
                if (collectionData) {
                    tempArr.push(...collectionData)
                }
            }
            last_evaluated_key = response.data.last_evaluated_key != null && response.data.last_evaluated_key !== "" ? encodeURIComponent(JSON.stringify(response.data.last_evaluated_key)) : null
        }
        while (last_evaluated_key !== null)
        return tempArr;
    }
    catch (error) {
        console.error(error)
        return []
    }
};

export const extractionFileSave = async (fileName, fileUrl, fileId, document_type_id) => {
    try {
        const selected_project = getSessionData("selected_project")

        const reqObj = {
            collection_item: {
                "file_name": fileName,
                "file_id": fileId,
                "file_url": fileUrl,
                "project_id": selected_project?.payload?.__auto_id__,
                "document_type": document_type_id,
                "uploaded_on": moment().format("YYYY-MM-DD HH:mm:ss"),
                "training_status": "Draft",
                "uploaded_via": "Direct Upload"
            }
        }
        const upload_reponse = await TemplateExtractionApi.uploadExtractionFile(JSON.stringify(reqObj));
        return upload_reponse
    } catch (error) {
        return error
    }
}
